<template>
  <div class="chat" title="Chat">
    <i class="isax-message"></i>
  </div>
</template>
<script>
export default {
  data() {
    return {

    }
  },
  methods: {

  },
  created() {

  }
}
</script>
<style lang="scss">
.chat{
  width: 30px;
  &:hover {
    cursor: pointer;
  }
  .isax-message:before{
    font-size: var(--font-size-icon);
    color: var(--color-icon);
  }
}
</style>
